/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_8f3a2b52{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_8f3a2b52{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_8f3a2b52{-ms-flex-negative:0;flex-shrink:0;display:inherit}"}]);
export const root = "root_8f3a2b52";
export const rootVertical = "rootVertical_8f3a2b52";
export const item = "item_8f3a2b52";